import { useRuntimeThemeStore } from '@core/store/runtimeThemeStore';

export function useRuntimeTheme() {
  const primaryColor = useRuntimeThemeStore((s) => s.primaryColor);
  const secondaryColor = useRuntimeThemeStore((s) => s.secondaryColor);
  const backgroundColor = useRuntimeThemeStore((s) => s.backgroundColor);
  const textColor = useRuntimeThemeStore((s) => s.textColor);
  return { primaryColor, secondaryColor, backgroundColor, textColor };
}
